import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = process.env.REACT_APP_TOKEN;
    if (token) {
      headers.set("Authorization", `Token ${token}`);
    }
    return headers;
  },
});

const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery,
  tagTypes: ["auth", "user", "clientLeads", "client", "project", "task"],
  endpoints: builder => ({}),
});

export default baseApi;
